<template>
    <div :class="['margin-items md-layout-item item no-padding ' + mdSize1, { 'md-layout' : info }]">
      <div :class="[{ 'half-width' : info }]">
        <div :class="'md-layout-item item no-padding '">
          <div class="margin-item-name">
            {{name}}
              <div v-if="name == 'Cto. de cultivo (USD/ha)'" @click="notify()" class="notification"><svg-icon type="mdi" :path="icons.info"></svg-icon></div>
          </div>
        </div>
        <div :class="'md-layout-item item pad-right-5 '">
          <md-button class="md-info md-sm" @click="clickUp1"><strong>+</strong></md-button>
          <input type="text" class="md-input" v-model="val1" @input="emitTyping1" @keydown.enter="keyDown1">
          <md-button class="md-info md-sm" @click="clickDown1"><strong>-</strong></md-button>
          <br>
          <md-button v-if="data.doble" class="md-info md-sm" @click="clickUp2"><strong>+</strong></md-button>
          <input v-if="data.doble" type="text" class="md-input" v-model="val2" @input="emitTyping2" @keydown.enter="keyDown2">
          <md-button v-if="data.doble" class="md-info md-sm" @click="clickDown2"><strong>-</strong></md-button>
        </div>
      </div>
      <div v-if="info" :class="[{ 'half-width' : info }]">
        <div v-if="info" class="md-layout-item item no-padding">
          <div class="margin-item-name">{{info.name}}</div>
        </div>
        <div v-if="info" class="md-layout-item item no-padding">
          <div class="margin-item-info-value">{{info.value1}}</div>
          <div v-if="data.doble" class="margin-item-info-value">{{info.value2}}</div>
        </div>
    </div>
    </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiInformationSlabCircle } from '@mdi/js'
export default {
  name: 'margin-item',
  props: ['name','data', 'type'],
  components: {SvgIcon},


  data() {
    return {
      val1: this.data.value1,
      val2: this.data.value2,
      info: this.data.info,
      icons: {
        info: mdiInformationSlabCircle,
      },
    }
  },
  computed: {
    mdSize1() {
      return (!this.data.info) ? 'md-size-15' : 'md-size-22';
    },
    mdSize2() {
      return (!this.data.info) ? 'md-size-20' : 'md-size-15';
    },
    mdSize3() {
      return (!this.data.info) ? 'md-size-80' : 'md-size-40';
    }
  },
  methods: {
    isFloat(n){
      return Number(n) === n && n % 1 !== 0;
    },
    clickUp1() {
      this.val1++;
      if (this.isFloat(this.val1))
        this.val1 = parseFloat(this.val1).toFixed(1);
      this.$emit('update-value1', this.val1, this.type);
    },
    clickDown1() {
      this.val1--;
      if (this.isFloat(this.val1))
        this.val1 = parseFloat(this.val1).toFixed(1);
      this.$emit('update-value1', this.val1, this.type);
    },
    clickUp2() {
      this.val2++;
      if (this.isFloat(this.val2))
        this.val1 = parseFloat(this.val2).toFixed(1);
      this.$emit('update-value2', this.val2, this.type);
    },
    clickDown2() {
      this.val2--;
      if (this.isFloat(this.val2))
        this.val1 = parseFloat(this.val2).toFixed(1);
      this.$emit('update-value2', this.val2, this.type);
    },
    keyDown1() {
      this.$emit('update-value1', this.val1, this.type);
    },
     keyDown2() {
      this.$emit('update-value2', this.val2, this.type);
    },
    emitTyping1() {
      this.$emit('update-value1', this.val1, this.type);
    },
    emitTyping2() {
      this.$emit('update-value2', this.val2, this.type);
    },
    notify() {
      const exists = document.querySelector('.alert');
      if (exists) return;

      this.$notifications?.closeAll?.();

      const timeout = 4000;
      this.isShowing = true;

      this.$notify(
        {
          message: 'Costo total, incluye cosecha, no incluye alquiler ni gastos de comercialización',
          icon: 'add_alert',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'tooltip',
          timeout
        });
        
        const checker = setInterval(() => {
        const stillExists = document.querySelector('.alert');
        if (!stillExists) {
          clearInterval(checker);
          this.isShowing = false;
        }
      }, 100);
    },
  }
}
</script>
<style>

.margin-box{
  position: relative;
}
#margins-menu .item{
  text-align: center;
}
#margins-menu .md-button{
  min-width: 25px;
}
#margins-menu span{
  font-weight: bold;
  line-height: 35px;
  margin-right:3px;
  font-size: 12px;
}
#margins-menu .md-ripple{
  padding: 5px !important;
}
#margins-menu .md-input{
  width: 40px;
  height: 25px;
  font-size: 14px;
  margin-top:5px;
  text-align: center;
}
.margin-items .margin-item-name .notification{
    position: absolute;
    bottom: 1%;
    right: 1%;
    cursor: pointer;
}
.margin-items .margin-item-name .notification svg{
height: 1rem;
}
.alert-tooltip{
  background-color: #f0f4ff !important;
  color: #333 !important;
  border: 1px solid #bbb !important;
  font-size: 14px !important;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19) !important;
  width: 35% !important;
}
.alert-tooltip span{
  max-width: 90% !important;
}
.alert-tooltip .close{
  color: #000 !important;
}
.info-tooltip {
  font-size: 11px;
  line-height: 1.1em;
  z-index: 9999999999 !important;
}
.info-tooltip.md-tooltip-bottom{
  top: 10% !important;
}
.pad-right-5{
  padding-right: 5px !important;
}
.margin-item-name{
  font-size: 12px;
  line-height: 1.2em;
  font-weight:bold;
  text-align: center;
  margin-top:4px;
}
.margin-item-name i{
  position: absolute;
  bottom: 1%;
  right: 1%;
  cursor: pointer;
}

.no-padding{
    padding-right: 0;
    padding-left: 0;
}
.half-width{
  width: 50%;
}
.margin-item-info-value{
  font-size:14px;
  text-align: center;
  border: 1px solid #ddd;
  /* margin-right:5px; */
  padding: 1px;
  font-weight: bold;
  /* margin-top: 4px; */
  width: 50%;
  margin: 4px auto;
}

  .md-tooltip:after {
    left: 80% !important;
    right: 0% !important;
  }

@media screen and (max-width: 600px) {
  .info-tooltip.md-tooltip-bottom{
    top: 16% !important;
  }
  /* .half-width{
    width: 100%;
  } */

  .md-tooltip:after {
    left: 80% !important;
    right: 0% !important;
  }
}
</style>
